import React, { useEffect, useState } from "react";
import Navbar from "../components/AgentNavbar";
import { db } from "../firebase";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";

export default function AgentDashboard() {
  const [clients, setClients] = useState([]);
  const [recentTransactions, setRecentTransactions] = useState([]);
  const [pendingWithdrawals, setPendingWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  const currentUser = localStorage.getItem("currentUser") || "unknown";

  // Fetch Clients
  useEffect(() => {
    const clientsRef = collection(db, "users");
    const q =
      currentUser === "buksna"
        ? query(clientsRef) // buksna sees all clients
        : query(clientsRef, where("createdBy", "==", currentUser));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const clientsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setClients(clientsData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  // Fetch Transactions (Today)
  useEffect(() => {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const transactionsRef = collection(db, "transactions");
    const q =
      currentUser === "buksna"
        ? query(transactionsRef, where("timestamp", ">=", todayStart))
        : query(
            transactionsRef,
            where("createdBy", "==", currentUser),
            where("timestamp", ">=", todayStart)
          );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const txnsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setRecentTransactions(txnsData);
    });

    return () => unsubscribe();
  }, [currentUser]);

  // Fetch Pending Withdrawals
  useEffect(() => {
    const withdrawalsRef = collection(db, "withdrawals");
    const q =
      currentUser === "buksna"
        ? query(withdrawalsRef, where("status", "==", "Pending"))
        : query(
            withdrawalsRef,
            where("createdBy", "==", currentUser),
            where("status", "==", "Pending")
          );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const pendingData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPendingWithdrawals(pendingData);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return (
    <div style={{ display: "flex", height: "100vh", backgroundColor: "#f7fafc" }}>
      <Navbar />
      <main style={{ flexGrow: 1, padding: "2rem 3rem" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: 600, color: "#1e40af" }}>
          Welcome, {currentUser}!
        </h1>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "1rem",
            marginTop: "2rem",
          }}
        >
          {/* My Clients Box */}
          <div
            style={{
              backgroundColor: "white",
              padding: "1rem",
              borderRadius: "0.5rem",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ fontSize: "0.9rem", color: "#374151", marginBottom: "0.5rem" }}>
              My Clients
            </h3>
            <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>{clients.length}</p>
            <p style={{ fontSize: "0.75rem", color: "#6b7280" }}>
              Clients currently under management
            </p>
          </div>

          {/* Recent Transactions Today */}
          <div
            style={{
              backgroundColor: "white",
              padding: "1rem",
              borderRadius: "0.5rem",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ fontSize: "0.9rem", color: "#374151", marginBottom: "0.5rem" }}>
              Recent Transactions (Today)
            </h3>
            <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>
              {recentTransactions.length}
            </p>
            <p style={{ fontSize: "0.75rem", color: "#6b7280" }}>
              Transactions processed today
            </p>
          </div>

          {/* Pending Withdrawals */}
          <div
            style={{
              backgroundColor: "white",
              padding: "1rem",
              borderRadius: "0.5rem",
              boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ fontSize: "0.9rem", color: "#374151", marginBottom: "0.5rem" }}>
              Pending Withdrawals
            </h3>
            <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>
              {pendingWithdrawals.length}
            </p>
            <p style={{ fontSize: "0.75rem", color: "#6b7280" }}>
              Client withdrawals requiring attention
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
